import { SiteMetadata } from '~/types/siteMetadata'
import { graphql } from 'gatsby'
import { useStaticQuery } from 'gatsby'

const defaultMetadata: SiteMetadata = {
    title: 'Moving Borders',
    url: 'https://movingborders.org',
    description: {
        description:
            'The project MOVING BORDERS is a cooperative effort by seven European production houses, festivals and public bodies in the sphere of the performing arts and is co-funded by the Creative Europe Programme of the European Union.',
    },
    image: {
        file: {
            url: '',
        },
    },
}

export default () =>
    (useStaticQuery(graphql`
        query SiteMetadata {
            ...siteMetadataFragment
        }
    `).contentfulSiteMetadata as SiteMetadata) || defaultMetadata
